import React from 'react';
import { Nav } from 'react-bootstrap';

import {
  ProfileDropdownWithState,
} from 'Layout';

type State = {
};

class NavbarDefault extends React.Component<{}, State> {


  render() {
    return (
      <div className="nav-top">
        <Nav>
          <Nav.Link className="py-0 pr-0">
            <ProfileDropdownWithState />
          </Nav.Link>
        </Nav>
      </div>
    );
  }
}


export { NavbarDefault };
